<template src="./index.html"></template>
<script>
import {getdata} from "./data.js";
import seegj from "./seegj/index.vue";
import AssetsAndLiabilities from '../Draftgeneration/AssetsAndLiabilities/index.vue'
import AssetsAndLiabilitiesY from '../Draftgeneration/AssetsAndLiabilitiesY/index.vue'
import corporateIncomeTax from '../Draftgeneration/corporateIncomeTax/index.vue'
import SalesTaxReport from '../Draftgeneration/SalesTaxReport/index.vue'
import SmallScaleVAT from '../Draftgeneration/SmallScaleVAT/index.vue'
import valueAddedTax from '../Draftgeneration/valueAddedTax/index.vue'
import ConsolidatedStatement from  '../Draftgeneration/ConsolidatedStatement/index.vue'
import TaxableService from '../Draftgeneration/TaxableService/index.vue';
import GeneralReturn from '../Draftgeneration/GeneralReturn/index.vue';
import DisabilityPayment from '../Draftgeneration/DisabilityPayment/index.vue';
import AdditionalTax from '../Draftgeneration/AdditionalTax/index.vue';
import BalanceSheet from '../Draftgeneration/BalanceSheet/index.vue';
import {
		manuscriptquery,
	} from '../../../../api/Draftgeneration.js'
	import config from '../../../../../configHttp.js'
	import {
		getShuizList
	} from '../../../../api/bbmb.js'
export default {
  name: "xggj",
  components: {
    seegj,
	AssetsAndLiabilities,
	AssetsAndLiabilitiesY,
	corporateIncomeTax,
	SalesTaxReport,SmallScaleVAT,
	valueAddedTax,ConsolidatedStatement,
	TaxableService,
	GeneralReturn,
	DisabilityPayment,
	BalanceSheet,
	AdditionalTax
  },
  data: function () {
    return {
      searchdata: getdata().searchdata,
      searchlist: getdata().searchlist,
      searchdiag: false,
      outlist: [],
      headData: getdata().headData,
      tableData: getdata().tableData,
	  suosq: this.$getdefultMonth(),
	  pagination: getdata().pagination,
      shaidiag: false,
      tablekey: 0,
      overlength: 0,
	  detailtype:'',
	  seeNow:false,
	  Saleparams:null,
	  showbox: {
		yhs:false,
		showdetail:false,
	  	zzs:false,
	  	cwbbybqyyzx:false,
	  	cwbbybqywzx:false,
	  	cwbbxqy:false,
	  	zzsxgm:false,
	  	qysdsA:false,
		
		cztds: false,
		fcs:false,
		cwbbkjzd:false,
		cbj:false,
		whsy:false,
		tysl:false,
		tygh:false,
		tylj:false,
		hjbhs:false,
		ty:false,
		xfs:false,
	  },
	  showmintitle:true,
	Saleparam:{},
    };
  },
  created() {
	  this.manuscriptquery()
	  this.getShuizList()
  },
  mounted() {
	  if(this.$notemptyandnull(this.$route.query.Saleparam)){
		  this.showmintitle=false
	  		  this.suosq=this.$route.query.suosq
	  		  this.forckgj(
	  			 JSON.parse(this.$route.query.Saleparam)  
	  		  )
	  }
  },
  methods: {	  geOoverLength(e){
		  this.overlength = e;
		 
	  },
	  fortosee(taxval){
		  this.detailtype="tosee"
		  this.seeNow=true
		  this.Saleparams=taxval
		  this.showbox[taxval.sbbm] = true
	  },
	 
	  getShuizList(){
	  	getShuizList().then(res=>{
	  		this.searchlist.forEach(item=>{
	  			if(item.prop=="shuizId"){
	  				item.selectval=res.data.data.map(item=>{
	  					return{
	  						label:item.shuizmc,
	  						value:item.id
	  					}
	  				})
	  			}
	  		})
	  		let newarr=JSON.parse(JSON.stringify(this.searchlist))
	  		this.searchlist=newarr
	  	})
	  },
	 manuscriptexport(){
	 	let params = JSON.parse(JSON.stringify(this.searchdata))
	 	params.current = this.pagination.pageNum
	 	params.size = this.pagination.pageSize
	 	params.queryType = 3
	 	params.suosq = this.suosq
	 	let newparams = {
	 		downUrl: config.baseURL + "manuscript/manuscript/export",
	 		typeObj: {
	 			toForm: false,
	 			fileType: "xlsx",
	 		},
	 		params:params,
	 	};
	 	this.$downloadcommon(newparams);
	 },
	  //查询相关
	  manuscriptquery() {
	  	let params = JSON.parse(JSON.stringify(this.searchdata))
	  	params.current = this.pagination.pageNum
	  	params.size = this.pagination.pageSize
	  	params.queryType = 3
	  	params.suosq = this.suosq
	  	manuscriptquery(params).then(res => {
	  		this.pagination.total = res.data.data.total;
	  		this.tableData = res.data.data.records
			
	  	})
	  },
	  
	  sizechange(e) {
	  	this.pagination.pageSize = e
	  	this.manuscriptquery()
	  },
	  currentChange(e) {
	  	this.pagination.pageNum = e
	  	this.manuscriptquery()
	  },
	  submitSearch() {
	  	this.pagination.pageNum = 1
	  	this.pagination.paginationkey++
	  	this.manuscriptquery()
	  },
	  suosqchange() {
	  	this.pagination.pageNum = 1
	  	this.pagination.paginationkey++
	  	this.manuscriptquery()
	  },
    forckgj(Saleparam) {
	  this.Saleparam=Saleparam
	  this.suosq=this.suosq
      this.showbox.showdetail = true;
    },
    forback() {
		this.manuscriptquery()
   Object.keys(this.showbox).map(key => (this.showbox[key] = false));
	  this.$nextTick(()=>{
		  setTimeout(() => {
		  this.$refs.tablebox.dout();
		  }, 300);
	  })
	 
    },
    spanmethod({
    	row,
    	column,
    	rowIndex,
    	columnIndex
    }) {
    	if (columnIndex == 0 || columnIndex == 1) {
    		return {
    			rowspan: row.span > 0 ? row.span : 0,
    			colspan: row.span > 0 ? 1 : 0
    		};
    	} else {
    		return [1, 1];
    	}
    },
    forUpdateSearch() {
      this.searchdiag = true;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    closeshaidiag() {
      this.shaidiag = false;
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
